import PaymentMethod from "../onboarding/payment-method";
import Pricing from "../onboarding/pricing";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import AnimatedLayout from "~@/components/layout/AnimatedLayout";
import { pageTransition, pageVariants } from "~@/constants";
import {
  OnboardStatus,
  useGetOrganizationsQuery,
} from "~@/graphql/codegen/generated";
import useWatchOnboardStatus from "~@/subscriptions/useWatchOnboardStatus";

const Inactive: FC = () => {
  const [redirected, setRedirected] = useState(false);

  const { data: organizationsData } = useGetOrganizationsQuery();

  const currentOrganization = useMemo(() => {
    return organizationsData?.getOrganizations?.current;
  }, [organizationsData]);

  const onboardStatus = useMemo(
    () => currentOrganization?.onboardStatus,
    [currentOrganization]
  );

  const navigate = useNavigate();

  const redirect = useCallback(() => {
    if (redirected) return;
    switch (onboardStatus) {
      case OnboardStatus.VerifyCode:
        navigate("");
        break;
      case OnboardStatus.ChooseTariff:
        navigate("/pricing");
        break;
      case OnboardStatus.SignDocument:
        navigate("/signing");
        break;
      case OnboardStatus.SetPassword:
        navigate("/password");
        break;
      case OnboardStatus.AddPayment:
        navigate("/payment-method");
        break;
      default:
        break;
    }

    setRedirected(true);
  }, [onboardStatus, redirected, navigate]);

  useWatchOnboardStatus();

  useEffect(() => {
    redirect();
  }, [redirect]);

  return (
    <div className="onboarding">
      <Routes>
        <Route
          element={
            <AnimatedLayout
              variants={pageVariants}
              transition={pageTransition}
            />
          }
        >
          <Route index element={<Navigate to={"pricing"} replace />} />
          <Route path="pricing" element={<Pricing />} />
          <Route path="payment-method/*" element={<PaymentMethod />} />
        </Route>
      </Routes>
    </div>
  );
};

export default Inactive;
